import FormBody from './FormBody'

export default FormBody



// WEBPACK FOOTER //
// ./client/Modules/AuthNative/FormBody/index.js